export const SmileyHouseIcon = ({ dark = false }: { dark?: boolean }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill={dark ? "#A1AAC7" : "#3f5162"}
      viewBox="0 0 1000 1000"
      style={{ height: "20px" }}
    >
      <metadata>Svg Vector Icons : http://www.onlinewebfonts.com/icon</metadata>
      <g>
        <path d="M965.8,417.7l-123-110.2c0.6-3.4,0-6.9,0-10.4V144.6c0-35.1-28.1-63.6-62.7-63.6s-62.7,28.5-62.7,63.6v52.2L555.8,53c-32.2-32.6-84.4-32.6-116.6,0l-405,354.5c-32.2,32.6-32.2,80.4,0,113.1l111.3,44.7v324.8c0,44.9,35.9,81.4,80.3,81.4h542c44.4,0,80.3-36.4,80.3-81.4V576.6l117.9-45.8C998.1,498.2,998.1,450.3,965.8,417.7L965.8,417.7z M646.4,436c28,0,50.7,22.7,50.7,50.6c0,27.9-22.7,50.6-50.7,50.6s-50.7-22.7-50.7-50.6C595.8,458.7,618.4,436,646.4,436L646.4,436z M353.6,436c28,0,50.6,22.7,50.6,50.6c0,27.9-22.7,50.6-50.6,50.6c-28,0-50.6-22.7-50.6-50.6C302.9,458.7,325.6,436,353.6,436L353.6,436z M744,718.8C685.1,795.3,596,852.6,499.6,852.6c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-95.4,0-183.9-56.5-242.8-131.7c-11.6-14.9-9-36.4,5.8-48c6.1-4.8,13.4-7.2,20.6-7.3c10.4-0.2,20.8,4.3,27.8,13.1c45.7,58.4,114.5,92,188.7,92c75-0.1,144.2-34.1,189.9-93.6c6.9-8.9,17.3-13.5,27.7-13.4c7.2,0.1,14.5,2.4,20.6,7.1C752.7,682.4,755.5,703.9,744,718.8L744,718.8z" />
      </g>
    </svg>
  );
};
